module.exports = __webpack_public_path__ + "img/point_shop.bda4eed8.jpeg";